import { Reaction } from "./activeHeadline";
import { HeadlineFlag } from "./headline";
export default class Reader {
    constructor(gamestate) {
        this.interests = {};
        /* Interest for headlines that don't have any specific topic */
        this.miscInterest = 0.0;
        this.storylines = [];
        this.subscribed = false;
        for (let i = 0, n = Math.random() * 4; i < n; i++)
            this.interests[pick(gamestate.topicKeys)] = Math.random();
        this.miscInterest = Math.random();
    }
    read(headline, gamestate, isAdView = false) {
        let match = 0;
        if (headline.content.topics.length) {
            for (let topic of headline.content.topics) {
                match += this.interests[topic] || 0;
            }
            match = match / Math.pow(1.4, headline.content.topics.length - 1);
        }
        else {
            match = this.miscInterest;
        }
        if (headline.flagged(HeadlineFlag.MISLEADING_HEADLINE))
            match += 0.15;
        if (headline.flagged(HeadlineFlag.FEARMONGERING))
            match += 0.15;
        if (this.subscribed)
            match += 0.2;
        if (!isAdView)
            match *= 1.3333;
        /* Reduce the CTR of old news */
        match *= Math.pow(0.95, gamestate.turn - headline.writtenOn);
        /* Readers who enjoyed an article are more likely to read a later article
           about the same story */
        if (this.storylines.includes(headline.content.storyline))
            match += 0.2;
        /* Clickbait-iness affects CTR */
        let read = Math.random() / (0.8 + headline.content.clickbait * 0.1) < match;
        /* Now that the article is read, modify the reader's opinion based on
           the quality */
        let opinionModifier = (0.4 + headline.quality * 0.2);
        /* "Disappointment": reduce the opinion modifier for articles with higher
           clickbait than quality */
        if (headline.content.clickbait > headline.content.quality)
            opinionModifier -= 0.1 * headline.content.clickbait - headline.content.quality;
        let reaction;
        /* Fact check */
        if (headline.content.flags.includes(HeadlineFlag.MISLEADING_HEADLINE) && Math.random() < 0.33
            || headline.content.flags.includes(HeadlineFlag.FALSE) && Math.random() < 0.16) {
            opinionModifier *= 0.2;
            if (Math.random() < 0.35)
                reaction = Reaction.ANGRY;
        }
        if (headline.content.storyline && opinionModifier >= 0.8)
            this.storylines.push(headline.content.storyline);
        let share = read && Math.random() / opinionModifier < match * 0.2;
        let subscribe = read && Math.random() / opinionModifier < match * 0.1;
        if (Math.random() / opinionModifier < 0.35) {
            let reactionFlags = union(headline.content.flags, [
                HeadlineFlag.HEARTWARMING,
                HeadlineFlag.HILARIOUS,
                HeadlineFlag.INFURIATING,
                HeadlineFlag.INSPIRING,
                HeadlineFlag.SAD,
            ]);
            if (reactionFlags.length)
                reaction = REACTIONS[pick(reactionFlags)];
        }
        if (!this.subscribed && subscribe)
            this.subscribed = true;
        headline.addImpression(read, share, reaction);
    }
}
function union(a, b) {
    let res = [];
    for (let x of a)
        if (b.includes(x))
            res.push(x);
    return res;
}
function pick(array) {
    return array[Math.floor(Math.random() * array.length)];
}
const REACTIONS = {
    [HeadlineFlag.HEARTWARMING]: Reaction.HAPPY,
    [HeadlineFlag.HILARIOUS]: Reaction.LAUGHING,
    [HeadlineFlag.INFURIATING]: Reaction.ANGRY,
    [HeadlineFlag.INSPIRING]: Reaction.AWESTRUCK,
    [HeadlineFlag.SAD]: Reaction.SAD,
};
